import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Layout } from "./components/site/Layout";
import { SiteConfigProvider } from "./components/site/SiteConfig";
import Home from "./pages/Home";
import Particuliers from "./pages/Particuliers";
import Professionnels from "./pages/Professionnels";
import ServicePage from "./pages/ServicePage";
import Aides from "./pages/Aides";
import Methode from "./pages/Methode";
import APropos from "./pages/APropos";
import Zone from "./pages/Zone";
import FaqPage from "./pages/FaqPage";
import Ressources from "./pages/Ressources";
import ArticlePage from "./pages/ArticlePage";
import Contact from "./pages/Contact";
import Simulateur from "./pages/Simulateur";
import RendezVous from "./pages/RendezVous";
import MentionsLegales from "./pages/MentionsLegales";
import Cgv from "./pages/Cgv";
import Confidentialite from "./pages/Confidentialite";
import Cookies from "./pages/Cookies";
import NotFound from "./pages/NotFound";
import Tarifs from "./pages/Tarifs";
import ForfaitCheckout from "./pages/ForfaitCheckout";
import PaymentLink from "./pages/PaymentLink";
import { PaymentSuccess, PaymentCancel } from "./pages/PaymentResult";
import AdminPayments from "./admin/AdminPayments";
import AdminLinks from "./admin/AdminLinks";
import AdminForfaits from "./admin/AdminForfaits";
import { AuthProvider, RequireAdmin } from "./admin/AuthContext";
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import AdminLeads from "./admin/AdminLeads";
import AdminLeadDetail from "./admin/AdminLeadDetail";
import AdminAppointments from "./admin/AdminAppointments";
import AdminSlots from "./admin/AdminSlots";
import AdminSettings from "./admin/AdminSettings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteConfigProvider>
          <AuthProvider>
            <Routes>
              <Route element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="particuliers" element={<Particuliers />} />
                <Route path="professionnels" element={<Professionnels />} />
                <Route path="services/:slug" element={<ServicePage />} />
                <Route path="aides-financieres" element={<Aides />} />
                <Route path="notre-methode" element={<Methode />} />
                <Route path="a-propos" element={<APropos />} />
                <Route path="zone-intervention" element={<Zone />} />
                <Route path="faq" element={<FaqPage />} />
                <Route path="ressources" element={<Ressources />} />
                <Route path="ressources/:slug" element={<ArticlePage />} />
                <Route path="contact" element={<Contact />} />
                <Route path="simulateur" element={<Simulateur />} />
                <Route path="prendre-rdv" element={<RendezVous />} />
                <Route path="mentions-legales" element={<MentionsLegales />} />
                <Route path="cgv" element={<Cgv />} />
                <Route path="confidentialite" element={<Confidentialite />} />
                <Route path="cookies" element={<Cookies />} />
                <Route path="tarifs" element={<Tarifs />} />
                <Route path="tarifs/:id/paiement" element={<ForfaitCheckout />} />
                <Route path="paiement/succes" element={<PaymentSuccess />} />
                <Route path="paiement/non-abouti" element={<PaymentCancel />} />
                <Route path="paiement/:token" element={<PaymentLink />} />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="admin/login" element={<AdminLogin />} />
              <Route path="admin" element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
                <Route index element={<AdminDashboard />} />
                <Route path="demandes" element={<AdminLeads />} />
                <Route path="demandes/:id" element={<AdminLeadDetail />} />
                <Route path="rdv" element={<AdminAppointments />} />
                <Route path="creneaux" element={<AdminSlots />} />
                <Route path="parametres" element={<AdminSettings />} />
                <Route path="paiements" element={<AdminPayments />} />
                <Route path="liens" element={<AdminLinks />} />
                <Route path="forfaits" element={<AdminForfaits />} />
              </Route>
            </Routes>
            <Toaster position="top-right" richColors />
          </AuthProvider>
        </SiteConfigProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
